import shallowCheckAuthentication from './shallowCheckAuthentication';
import isEmpty from 'lodash/isEmpty';

export default function canPlayStream(stream = {}, userAuth, optimisitic = true) {
    // theoretically should be able to use `showKey` field
    return shallowCheckAuthentication(stream, userAuth, optimisitic);
};



// WEBPACK FOOTER //
// ./app/lib/auth/canPlayStream.js